<template>
  <div>
    <!-- <b-card
      class="mb-2 shadow"
      header="Historique des mandats"
      bg-variant="secondary"
      header-text-variant="light"
      header-tag="h6"
    > -->
      <div v-if="busy" class="d-flex justify-content-center mt-3">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-if="warrants.length > 0">
        <div v-for="(hm, index) in warrants" :key="index">
          <div v-if="mandatsFiltered(hm.mandats).length > 0">
            <b-card-sub-title class="my-3">
              {{ typeMandat(hm.mandats) }} du {{ toDate(hm.date) }}
              <span v-if="hm.facture.ID"
                >- Facture liée :
                <b-link
                  :to="{ name: 'invoiceView', params: { id: hm.facture.ID } }"
                  >{{ hm.facture.ID }}</b-link
                >
              </span>
              
              <span class="ml-3" v-if="hm.mandats.every( x => x.status == 'unused') && $store.getters.isSuperAdmin">
                <b-button @click="hm_delete(hm.ID)" size="sm" variant="danger">Supprimer</b-button>
              </span>
            </b-card-sub-title>
            <table
              class="table b-table table-striped table-hover b-table-fixed table-sm"
            >
              <tr v-for="(item, i) in mandatsFiltered(hm.mandats)" :key="i">
                <td>{{ toDate(item.date_ouverture) }}</td>
                <td>
                  <strong
                    ><b-link
                      :to="{ name: 'warrantView', params: { id: item.ID } }"
                      >{{ item.ID }}</b-link
                    ></strong
                  >
                </td>
                <td>{{ item.status_i18n }}</td>
                <td>
                  <strong
                    ><b-link
                      v-if="item.status !== 'unused'"
                      :to="{
                        name: 'debtorView',
                        params: { id: item.debiteurID },
                      }"
                      >{{ item.debiteur }}</b-link
                    ></strong
                  >
                  <span v-if="item.status == 'unused'">
                    <b-button
                      :to="{
                        name: 'warrantOpen',
                        params: { id: item.ID },
                      }"
                      size="sm"
                      class="btn-xs"
                      >Ouvrir</b-button
                    >
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-else>
        <b-card-body>
          <b-alert show>Pas de mandats</b-alert>
        </b-card-body>
      </div>
      <b-button
        v-if="!finished && !busy"
        variant="info"
        @click="load_continue()"
        >Plus...</b-button
      >
    <!-- </b-card> -->
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import creditors from "@/services/creditors.js";
export default {
  name: "creditor-warrants",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
      offset: 0,
      finished: false,
      percentage: 0,
      warrants: [],
      warrantsFields: [
        {
          key: "date_ouverture",
          label: "Date",
          sortable: true,
        },
        {
          key: "ID",
          label: "Numéro de mandat",
          sortable: true,
        },
        {
          key: "status_i18n",
          label: "Statut",
          sortable: true,
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.busy = true;
      this.loaded = false,
      this.offset = 0,
      this.finished = false,
      this.percentage = 0,
      this.warrants = [],
      creditors.warrants(this.$props.id).then((response) => {
        this.warrants = [...this.warrants, ...response.data.records];
        this.offset = response.data.offset;
        this.loaded = true;
        this.busy = false;
        if (!response.data.continue) {
          this.finish();
        }
      });
    },
    hm_delete(hmID) {
      this.$bvModal.msgBoxConfirm("Êtes-vous sûr de vouloir supprimer ces mandats? Cette opération n'entraîne pas de facturation, ni de note de crédit !!").then((ok) => {
        if (!ok) return;
        creditors.warrants_delete(hmID).then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Opération réussie", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            this.load();
          }
        });
      });
    },
    
    load_continue() {
      this.busy = true;
      creditors.warrants(this.$props.id, this.offset).then((response) => {
        this.warrants = [...this.warrants, ...response.data.records];
        this.offset = response.data.offset;
        this.percentage = response.data.percentage;
        this.busy = false;
        if (!response.data.continue) {
          this.finish();
        }
      });
    },
    finish() {
      this.finished = true;
    },
    mandatsFiltered(hm) {
      if (this.active) {
        return hm.filter((x) => x.status == "open");
      }
      return hm;
    },
    typeMandat(hm) {
      if (hm.length > 1) {
        return "Carnet de " + hm.length + " mandats";
      }
      return "Mandat unique";
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>